import { AxiosInstance } from 'axios';
import * as CashRegisterReportService from './services';

export type CashRegisterReportServiceType = ReturnType<typeof CashRegisterReportService.exportPDF>;

export const initCashRegisterReportService = (
  axios: AxiosInstance
): CashRegisterReportServiceType => CashRegisterReportService.exportPDF(axios);
